/**
 *
 * App.js
 *
 */

import React, { useEffect } from "react";
import Routes from "../../components/Routes";
import { Switch, Router } from "react-router-dom";
import { getUserConfirmation } from "./getUserConfirmation";
import history from "../../history";
import { withErrorBoundary } from "../../utils/functions/withErrorBoundary";
import { AlertInfo } from "../../components";
import {
  clearUnauthorizedNotif,
  hideError,
  resetSessionExpired,
  showError,
} from "../../globalRedux/actions";
import { compose } from "underscore";
import { connect } from "react-redux";
const errorMessageDefault =
  "We are facing some technical issue, we're sorry for the inconvenience.";
const App = props => {
  const {
    errorMessage = "We are facing some technical issues, and we are working very hard to resolve the issue.",
    isModalErrorOpen,
    hideError,
    showError,
    isSessionExpired,
    resetSessionExpired,
  } = props;


  const GTM_ID =
    process.env.REACT_APP_ENV.trim() === "development" ||
    process.env.REACT_APP_ENV.trim() === "uat"
      ? process.env.REACT_APP_GTM_UAT.trim()
      : process.env.REACT_APP_GTM_PROD.trim();

  const handleSessionExpired = () => {
    console.log("handleSessionExpired");
    resetSessionExpired();
    window.my.postMessage({
      api: "getAuthCode",
      scopes: ["auth_base", "auth_user", "USER_INFO_EKYC", "FIN_PROFILE"],
      event: "getAccessToken",
    });
  };

  useEffect(() => {
    const nonce = document
    .querySelector("meta[name='csp-nonce']")
    ?.getAttribute("content");

    const scriptTemplate = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');
    n&&j.setAttribute('nonce', '${nonce}');f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');`;

    const noScriptTemplate = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}&gtm_auth=&gtm_preview=&gtm_cookies_win=x"
      height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`

    const script = document.createElement("script");
    const noScript = document.createElement("noscript");

    if (nonce) {
      script.setAttribute("nonce", nonce);
    }

    script.textContent = scriptTemplate;
    noScript.textContent = noScriptTemplate;

    document.head.insertBefore(script, document.head.firstChild);
    document.body.insertBefore(noScript, document.body.firstChild)

    const triggerError = window.eventManager.on("TRIGGER_ERROR", res => {
      if (process.env.REACT_APP_ENV.trim() === "production") {
        showError(errorMessageDefault);
      } else {
        showError(res);
      }
    });

    return () => {
      triggerError.clearEvents();
      document.head.removeChild(script);
      document.body.removeChild(noScript);
    };
  }, []);

  return (
    <>
      <AlertInfo
        handleAction={() => {
          //sendLogError({ app: true });
          props.clearUnauthorizedNotif();
          hideError();
        }}
        description={errorMessage}
        isOpen={isModalErrorOpen || props.unauthorizedNotif}
        isTimeout
      />
      <AlertInfo
        handleAction={handleSessionExpired}
        description={"Your session has expired. Please click OK to continue."}
        isOpen={isSessionExpired}
        fullWidthBtn
        btnText="OK"
      />

      <Router getUserConfirmation={getUserConfirmation} history={history}>
        <Switch>
          <Routes />
        </Switch>
      </Router>
    </>
  );
};

const withConnect = connect(
  state => ({
    ...state.globalReducer.globalData,
  }),
  {
    clearUnauthorizedNotif,
    hideError,
    showError,
    resetSessionExpired,
  }
);

export default compose(
  withConnect,
  withErrorBoundary
)(App);
